import axios from 'axios'
import request from 'services/axios'

export const AddBoxFirst = async (payload: IAddBoxFirstPayload) => {
    const { data }: { data: IAddFirstBoxResponse } = await request.post(
        '/moneypool_management/moneypool/create/',
        {
            name: payload.name,
            image_id: payload.image_id,
            bank_balance: 0,
            interval: payload.interval,
            share_value: payload.share_value,
            made_by_kuching: payload.made_by_kuching,
            trust_state: 'trst',
            day_of_duetion: payload.day_of_duetion,
            box_setting: payload.box_setting,
        }
    )
    return data
}
export const AddCustomImage = async (payload: { file: File; id: number }) => {
    const formData = new FormData()
    formData.append('custom_avatar', payload.file, payload.file.name)
    const userProfile = JSON.parse(window.localStorage.getItem('user')!)
    const { data }: { data: IAddFirstBoxResponse } = await axios.post(
        `https://gethamyan.ir/moneypool_management/moneypool/${payload.id}/update/`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept-Language': 'fa-IR',
                'CLIENT-TYPE': 'pwa',
                Authorization: `JWT ${userProfile?.token} `,
            },
        }
    )
    return data
}

export const AddBoxFirstManagerOrders = async (
    payload: IAddBoxFirstManagerOrdersPayload
) => {
    const { data } = await request.put(
        `/api/v1/moneypools/${payload.moneyPool}/poolships/${payload.poolShip}/`,
        {
            member: {
                has_rated: false,
                is_box_member: false,
                l: [],
                id: 0,
                global_credit: 0.0,
                last_global_credit: -10000.0,
                global_score: 0.0,
                last_global_score: 0.0,
                is_staff: false,
                show_marketing_banner: false,
            },
            number_of_shares: 1,
            role: 'own',
            to_be_paid_portion: payload.to_be_paid_portion,
            loans: payload.loans,
            cashins: payload.cashins,
            cashouts: payload.cashouts,
        }
    )
    return data
}
